import React, { useState } from "react";
import { Box, Button, TextField, Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { H5, H4 } from "../../components/Typography";
import { createNominee } from "../../redux/actions/UserAction";
import { load } from "../../constants/storage";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { allocationLength } from "../../common/common";
import DashboardNavbar from "../../components/DashboardNavbar";

type FormValues = {
  nomineeName: string;
  allocationPercentage: string;
  dob: any;
  relationShip: string;
  guardianName: string;
  guardianRelationship: string;
  //nominee2
  nomineeNameSecond: string;
  allocationPercentageSecond: string;
  dobSecond: any;
  relationShipSecond: string;
  guardianNameSecond: string;
  guardianRelationshipSecond: string;
  //third
  nomineeNameThird: string;
  allocationPercentageThird: string;
  dobThird: any;
  relationShipThird: string;
  guardianNameThird: string;
  guardianRelationshipThird: string;
};

type FormErrors = {
  nomineeName?: string;
  allocationPercentage?: string;
  dob?: any;
  relationShip?: string;
  guardianName?: string;
  guardianRelationship?: string;
  //nominee2
  nomineeNameSecond?: string;
  allocationPercentageSecond?: string;
  dobSecond?: any;
  relationShipSecond?: string;
  guardianNameSecond?: string;
  guardianRelationshipSecond?: string;
  //third
  nomineeNameThird?: string;
  allocationPercentageThird?: string;
  dobThird?: any;
  relationShipThird?: string;
  guardianNameThird?: string;
  guardianRelationshipThird?: string;
};

const AddNomineeScreen = () => {
  const [formValues, setFormValues] = useState<FormValues>({
    nomineeName: "",
    allocationPercentage: "",
    dob: "",
    relationShip: "",
    guardianName: "",
    guardianRelationship: "",
    //nominee2
    nomineeNameSecond: "",
    allocationPercentageSecond: "",
    dobSecond: "",
    relationShipSecond: "",
    guardianNameSecond: "",
    guardianRelationshipSecond: "",
    //third
    nomineeNameThird: "",
    allocationPercentageThird: "",
    dobThird: "",
    relationShipThird: "",
    guardianNameThird: "",
    guardianRelationshipThird: "",
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [gardian, showGardian] = useState(false);
  const [gardianSecond, showGardianSecond] = useState(false);
  const [gardianThird, showGardianThird] = useState(false);
  const [second, setSecond] = useState(false);
  const [third, setThird] = useState(false);
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  let routeData = useLocation();
  const { data } = routeData.state;
  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }
  const [loading, setLoading] = useState(false);
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    if (name === "dob") {
      setFormValues((prevFormValues) => {
        const updatedFormValues = { ...prevFormValues, [name]: value };
        const inputDateObj = new Date(updatedFormValues.dob);

        let inputdate = inputDateObj.setFullYear(inputDateObj.getFullYear());
        const today = new Date();
        let todaydate = today.setFullYear(today.getFullYear() - 18);

        if (inputdate > todaydate) {
          showGardian(true);
        } else {
          showGardian(false);
        }
        return updatedFormValues;
      });
      setFormErrors({ ...formErrors, [name]: "" });
    } else if (name === "dobSecond") {
      setFormValues((prevFormValues) => {
        const updatedFormValues = { ...prevFormValues, [name]: value };

        const inputDateObj = new Date(updatedFormValues.dobSecond);
        let inputdate = inputDateObj.setFullYear(inputDateObj.getFullYear());
        const today = new Date();
        let todaydate = today.setFullYear(today.getFullYear() - 18);

        if (inputdate > todaydate) {
          showGardianSecond(true);
        } else {
          showGardianSecond(false);
        }
        return updatedFormValues;
      });
      setFormErrors({ ...formErrors, [name]: "" });
    } else if (name === "dobThird") {
      setFormValues((prevFormValues) => {
        const updatedFormValues = { ...prevFormValues, [name]: value };

        const inputDateObj = new Date(updatedFormValues.dobThird);
        let inputdate = inputDateObj.setFullYear(inputDateObj.getFullYear());
        const today = new Date();
        let todaydate = today.setFullYear(today.getFullYear() - 18);

        if (inputdate > todaydate) {
          showGardianThird(true);
        } else {
          showGardianThird(false);
        }
        return updatedFormValues;
      });
      setFormErrors({ ...formErrors, [name]: "" });
    } else {
      setFormValues({ ...formValues, [name]: value });
      setFormErrors({ ...formErrors, [name]: "" });
    }
  }

  React.useEffect(() => {
    if (data?.length === 1) {
      showGardian(data[0]?.minor_nominee);
      setFormValues((prevState) => ({
        ...prevState,
        nomineeName: data[0]?.nominee_name ?? "",
        allocationPercentage: data[0]?.percentage.toString() ?? "",
        dob: moment(data[0]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShip: data[0]?.nominee_relationship ?? "",
        guardianName: data[0]?.guardian_name ?? "",
        guardianRelationship: data[0]?.guardian_relationship ?? "",
      }));
    }
    if (data?.length === 2) {
      setSecond(true);
      showGardian(data[0]?.minor_nominee);
      showGardianSecond(data[1]?.minor_nominee);
      setFormValues((prevState) => ({
        ...prevState,
        nomineeName: data[0]?.nominee_name ?? "",
        allocationPercentage: data[0]?.percentage.toString() ?? "",
        dob: moment(data[0]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShip: data[0]?.nominee_relationship ?? "",
        guardianName: data[0]?.guardian_name ?? "",
        guardianRelationship: data[0]?.guardian_relationship ?? "",
        nomineeNameSecond: data[1]?.nominee_name ?? "",
        allocationPercentageSecond: data[1]?.percentage.toString() ?? "",
        dobSecond: moment(data[1]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShipSecond: data[1]?.nominee_relationship ?? "",
        guardianNameSecond: data[1]?.guardian_name ?? "",
        guardianRelationshipSecond: data[1]?.guardian_relationship ?? "",
      }));
    }
    if (data?.length === 3) {
      setSecond(true);
      setThird(true);
      showGardian(data[0]?.minor_nominee);
      showGardianSecond(data[1]?.minor_nominee);
      showGardianThird(data[2]?.minor_nominee);
      setFormValues((prevState) => ({
        ...prevState,
        nomineeName: data[0]?.nominee_name ?? "",
        allocationPercentage: data[0]?.percentage.toString() ?? "",
        dob: moment(data[0]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShip: data[0]?.nominee_relationship ?? "",
        guardianName: data[0]?.guardian_name ?? "",
        guardianRelationship: data[0]?.guardian_relationship ?? "",
        nomineeNameSecond: data[1]?.nominee_name ?? "",
        allocationPercentageSecond: data[1]?.percentage.toString() ?? "",
        dobSecond: moment(data[1]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShipSecond: data[1]?.nominee_relationship ?? "",
        guardianNameSecond: data[1]?.guardian_name ?? "",
        guardianRelationshipSecond: data[1]?.guardian_relationship ?? "",
        nomineeNameThird: data[2]?.nominee_name ?? "",
        allocationPercentageThird: data[2]?.percentage.toString() ?? "",
        dobThird: moment(data[2]?.nominee_dob).format("YYYY-MM-DD") ?? "",
        relationShipThird: data[2]?.nominee_relationship ?? "",
        guardianNameThird: data[2]?.guardian_name ?? "",
        guardianRelationshipThird: data[2]?.guardian_relationship ?? "",
      }));
    }
  }, []);

  const handleRelationShip = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      relationShip: event.target.value,
    }));
  };
  const handleRelationShipSecond = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      relationShipSecond: event.target.value,
    }));
  };
  const handleRelationShipThird = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      relationShipThird: event.target.value,
    }));
  };

  const handleGRelationShip = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      guardianRelationship: event.target.value,
    }));
  };
  const handleGRelationShipSecond = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      guardianRelationshipSecond: event.target.value,
    }));
  };
  const handleGRelationShipThird = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      guardianRelationshipThird: event.target.value,
    }));
  };

  const handleSaveClick = () => {
    const newErrors: FormErrors = {};

    if (!formValues.dob) {
      newErrors.dob = "Please select a date";
    }
    if (!formValues.nomineeName) {
      newErrors.nomineeName = "Nominee name cannot be empty.";
    }
    if (!formValues.allocationPercentage) {
      newErrors.allocationPercentage = "Allocation percentage cannot be empty.";
    }
    if (Number(formValues.allocationPercentage) > 100) {
      newErrors.allocationPercentage =
        "Total allocation percentage cannot be more than 100";
    }
    if (gardian) {
      if (!formValues.guardianRelationship) {
        newErrors.guardianRelationship =
          "Guardian Relationship cannot be empty.";
      }
      if (!formValues.guardianName) {
        newErrors.guardianName = "Guardian Name cannot be empty.";
      }
    }

    ///Nomine 2nd want to add
    if (second) {
      if (!formValues.dobSecond) {
        newErrors.dobSecond = "Please select a date";
      }
      if (!formValues.nomineeNameSecond) {
        newErrors.nomineeNameSecond = "Nominee name cannot be empty.";
      }
      if (!formValues.allocationPercentageSecond) {
        newErrors.allocationPercentageSecond =
          "Allocation percentage cannot be empty.";
      }
      if (
        Number(formValues.allocationPercentage) +
          Number(formValues.allocationPercentageSecond) >
        100
      ) {
        newErrors.allocationPercentageSecond =
          "Total allocation percentage cannot be more than 100";
      }
      if (gardianSecond) {
        if (!formValues.guardianRelationshipSecond) {
          newErrors.guardianRelationshipSecond =
            "Guardian Relationship cannot be empty.";
        }
        if (!formValues.guardianNameSecond) {
          newErrors.guardianNameSecond = "Guardian Name cannot be empty.";
        }
      }
    }
    ///Nomine 3rd want to add
    if (third) {
      if (!formValues.dobThird) {
        newErrors.dobThird = "Please select a date";
      }
      if (!formValues.nomineeNameThird) {
        newErrors.nomineeNameThird = "Nominee name cannot be empty.";
      }
      if (!formValues.allocationPercentageThird) {
        newErrors.allocationPercentageThird =
          "Allocation percentage cannot be empty.";
      }
      if (
        Number(formValues.allocationPercentage) +
          Number(formValues.allocationPercentageSecond) +
          Number(formValues.allocationPercentageThird) <
        100
      ) {
        newErrors.allocationPercentageThird =
          "Total allocation percentage cannot be more than 100";
      }
      if (gardianThird) {
        if (!formValues.guardianRelationshipThird) {
          newErrors.guardianRelationshipThird =
            "Guardian Relationship cannot be empty.";
        }
        if (!formValues.guardianNameThird) {
          newErrors.guardianNameThird = "Guardian Name cannot be empty.";
        }
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      let userDetail: any = load("userData");
      let finalUser = JSON.parse(userDetail);
      let token = load("token");
      let nominee1Data = {
        nominee_name: formValues.nomineeName,
        nominee_dob: formValues.dob,
        nominee_relationship: formValues.relationShip,
        percentage: formValues.allocationPercentage,
        guardian_name: formValues?.guardianName ?? " ",
        guardian_relationship: formValues?.guardianRelationship ?? " ",
        minor_nominee: gardian ? true : false,
      };
      let nominee2Data = second
        ? {
            nominee_name: formValues.nomineeNameSecond,
            nominee_dob: formValues.dobSecond,
            nominee_relationship: formValues.relationShipSecond,
            percentage: formValues.allocationPercentageSecond,
            guardian_name: formValues?.guardianNameSecond ?? " ",
            guardian_relationship:
              formValues?.guardianRelationshipSecond ?? " ",
            minor_nominee: gardianSecond ? true : false,
          }
        : null;
      let nominee3Data = third
        ? {
            nominee_name: formValues.nomineeNameThird,
            nominee_dob: formValues.dobThird,
            nominee_relationship: formValues.relationShipThird,
            percentage: formValues.allocationPercentageThird,
            guardian_name: formValues?.guardianNameThird ?? "",
            guardian_relationship: formValues?.guardianRelationshipThird ?? " ",
            minor_nominee: gardianThird ? true : false,
          }
        : null;

      setLoading(true);
      const req = {
        id: finalUser.id,
        mobile: finalUser.mobile,
        partner: finalUser?.refcode,
        nominee1: nominee1Data,
        nominee2: nominee2Data,
        nominee3: nominee3Data,
      };
      dispatch(createNominee(req, `bearer ${token}`))
        .then(async (response: any) => {
          setLoading(false);
          if (response?.message == "Updated Nominee Details Successfully") {
            toast.success(response?.message);
            navigate("/nominee");
            return;
          }
          if (
            response?.message ==
            "Total Nominee Percentage should be equal to 100%"
          ) {
            toast.error(response?.message);
            return;
          }
          if (response?.fpdata?.error) {
            toast.error(response?.message);
            navigate("/nominee");
            return;
          }
          return;
        })
        .catch((error: any) => {
          toast.error("Error!, Please try again after sometime.");
          navigate("/nominee");
          setLoading(false);
        });
    }
  };

  return (
    <>
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100vh"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            p: 5,
            flexDirection: "column",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            pl: {
              xs: 3,
            },
            pr: {
              xs: 3,
            },
          }}
        >
          <>
            <H5
              fontWeight={600}
              color="#595959"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                textAlign: "center",
                mt: 0.8,
                color: "#000000",
                fontSize: 16,
              }}
            >
              Nominee 1
            </H5>
            <TextField
              label="Nominee Name"
              name="nomineeName"
              value={formValues.nomineeName ? formValues.nomineeName : ""}
              error={!!formErrors.nomineeName}
              helperText={formErrors.nomineeName}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              margin="normal"
              sx={textInputStyles}
            />
            <TextField
              label="Allocation Percentage"
              onChange={handleInputChange}
              fullWidth
              inputProps={{
                maxLength: allocationLength,
              }}
              variant="outlined"
              margin="normal"
              sx={textInputStyles}
              name="allocationPercentage"
              value={
                formValues.allocationPercentage
                  ? formValues.allocationPercentage
                  : ""
              }
              error={!!formErrors.allocationPercentage}
              helperText={formErrors.allocationPercentage}
            />
            <TextField
              name="dob"
              label="Date of Birth"
              type="date"
              sx={textInputStyles}
              value={formValues.dob}
              error={!!formErrors.dob}
              helperText={formErrors.dob}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Select
              sx={textInputStyles}
              value={formValues.relationShip ? formValues.relationShip : ""}
              required
              onChange={handleRelationShip}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <H4 style={{ color: "#C0C0C0" }}>RelationShip</H4>;
                }
                return selected;
              }}
            >
              <MenuItem disabled value="">
                <H4>RelationShip</H4>
              </MenuItem>
              <MenuItem value={"Father"}>Father</MenuItem>
              <MenuItem value={"Mother"}>Mother</MenuItem>
              <MenuItem value={"Brother"}>Brother</MenuItem>
              <MenuItem value={"Sister"}>Sister</MenuItem>
              <MenuItem value={"Spouse"}>Spouse</MenuItem>
              <MenuItem value={"Children"}>Children</MenuItem>
            </Select>
            {gardian && (
              <>
                <TextField
                  label="Guardian Name"
                  onChange={handleInputChange}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  sx={textInputStyles}
                  name="guardianName"
                  value={formValues.guardianName ? formValues.guardianName : ""}
                  error={!!formErrors.guardianName}
                  helperText={formErrors.guardianName}
                />
                <Select
                  sx={textInputStyles}
                  value={
                    formValues.guardianRelationship
                      ? formValues.guardianRelationship
                      : ""
                  }
                  required
                  onChange={handleGRelationShip}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <H4 style={{ color: "#C0C0C0" }}>
                          Guardian RelationShip
                        </H4>
                      );
                    }
                    return selected;
                  }}
                >
                  <MenuItem disabled value="">
                    <H4>Guardian RelationShip</H4>
                  </MenuItem>
                  <MenuItem value={"Father"}>Father</MenuItem>
                  <MenuItem value={"Mother"}>Mother</MenuItem>
                  <MenuItem value={"Brother"}>Brother</MenuItem>
                  <MenuItem value={"Sister"}>Sister</MenuItem>
                  <MenuItem value={"Spouse"}>Spouse</MenuItem>
                  <MenuItem value={"Children"}>Children</MenuItem>
                </Select>
              </>
            )}
            {second ? null : (
              <Box sx={buttonContainer}>
                <Button variant="contained" onClick={handleSaveClick} sx={add}>
                  {data?.length === 1 ? "Update" : "Add"}
                </Button>
              </Box>
            )}

            <Box
              sx={{
                justifyContent: "center",
                alignSelf: "center",
                width: {
                  md: "30%",
                  xs: "100%",
                },
                marginTop: 5,
              }}
            >
              {third ? null : (
                <Button
                  type="submit"
                  size="medium"
                  sx={deleteButton}
                  onClick={() => {
                    setSecond(!second);
                  }}
                >
                  {second ? "Delete Nominee 2" : "Add nominee 2"}
                </Button>
              )}
            </Box>
          </>
          {second && (
            <>
              <H5
                fontWeight={600}
                color="#595959"
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                  mt: 1.2,
                  color: "#000000",
                  fontSize: 16,
                }}
              >
                Nominee 2
              </H5>
              <TextField
                label="Nominee Name"
                name="nomineeNameSecond"
                value={
                  formValues.nomineeNameSecond
                    ? formValues.nomineeNameSecond
                    : ""
                }
                error={!!formErrors.nomineeNameSecond}
                helperText={formErrors.nomineeNameSecond}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                margin="normal"
                sx={textInputStyles}
              />
              <TextField
                label="Allocation Percentage"
                onChange={handleInputChange}
                fullWidth
                inputProps={{
                  maxLength: allocationLength,
                }}
                variant="outlined"
                margin="normal"
                sx={textInputStyles}
                name="allocationPercentageSecond"
                value={
                  formValues.allocationPercentageSecond
                    ? formValues.allocationPercentageSecond
                    : ""
                }
                error={!!formErrors.allocationPercentageSecond}
                helperText={formErrors.allocationPercentageSecond}
              />
              <TextField
                name="dobSecond"
                label="Date of Birth"
                type="date"
                sx={textInputStyles}
                value={formValues.dobSecond}
                error={!!formErrors.dobSecond}
                helperText={formErrors.dobSecond}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Select
                sx={textInputStyles}
                value={
                  formValues.relationShipSecond
                    ? formValues.relationShipSecond
                    : ""
                }
                required
                onChange={handleRelationShipSecond}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <H4 style={{ color: "#C0C0C0" }}>RelationShip</H4>;
                  }
                  return selected;
                }}
              >
                <MenuItem disabled value="">
                  <H4>RelationShip</H4>
                </MenuItem>
                <MenuItem value={"Father"}>Father</MenuItem>
                <MenuItem value={"Mother"}>Mother</MenuItem>
                <MenuItem value={"Brother"}>Brother</MenuItem>
                <MenuItem value={"Sister"}>Sister</MenuItem>
                <MenuItem value={"Spouse"}>Spouse</MenuItem>
                <MenuItem value={"Children"}>Children</MenuItem>
              </Select>
              {gardianSecond && (
                <>
                  <TextField
                    label="Guardian Name"
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    sx={textInputStyles}
                    name="guardianNameSecond"
                    value={
                      formValues.guardianNameSecond
                        ? formValues.guardianNameSecond
                        : ""
                    }
                    error={!!formErrors.guardianNameSecond}
                    helperText={formErrors.guardianNameSecond}
                  />
                  <Select
                    sx={textInputStyles}
                    value={
                      formValues.guardianRelationshipSecond
                        ? formValues.guardianRelationshipSecond
                        : ""
                    }
                    required
                    onChange={handleGRelationShipSecond}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return (
                          <H4 style={{ color: "#C0C0C0" }}>
                            Guardian RelationShip
                          </H4>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem disabled value="">
                      <H4>Guardian RelationShip</H4>
                    </MenuItem>
                    <MenuItem value={"Father"}>Father</MenuItem>
                    <MenuItem value={"Mother"}>Mother</MenuItem>
                    <MenuItem value={"Brother"}>Brother</MenuItem>
                    <MenuItem value={"Sister"}>Sister</MenuItem>
                    <MenuItem value={"Spouse"}>Spouse</MenuItem>
                    <MenuItem value={"Children"}>Children</MenuItem>
                  </Select>
                </>
              )}
              {third ? null : (
                <Box sx={buttonContainer}>
                  <Button
                    variant="contained"
                    onClick={handleSaveClick}
                    sx={add}
                  >
                    {data?.length === 2 ? "Update" : "Add"}
                  </Button>
                </Box>
              )}
              {
                <Box
                  sx={{
                    justifyContent: "center",
                    alignSelf: "center",
                    width: {
                      md: "30%",
                      xs: "100%",
                    },
                    marginTop: 5,
                  }}
                >
                  <Button
                    type="submit"
                    size="medium"
                    sx={deleteButton}
                    onClick={() => {
                      setThird(!third);
                    }}
                  >
                    {third ? "Delete Nominee 3" : "Add nominee 3"}
                  </Button>
                </Box>
              }
            </>
          )}
          {third && (
            <>
              <H5
                fontWeight={600}
                color="#595959"
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                  mt: 1.2,
                  color: "#000000",
                  fontSize: 16,
                }}
              >
                Nominee 3
              </H5>
              <TextField
                label="Nominee Name"
                name="nomineeNameThird"
                value={
                  formValues.nomineeNameThird ? formValues.nomineeNameThird : ""
                }
                error={!!formErrors.nomineeNameThird}
                helperText={formErrors.nomineeNameThird}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                margin="normal"
                sx={textInputStyles}
                // InputProps={{
                //   style: {
                //     height: "40px", // change this value to set the desired height
                //   },
                // }}
              />
              <TextField
                label="Allocation Percentage"
                onChange={handleInputChange}
                fullWidth
                inputProps={{
                  maxLength: allocationLength,
                }}
                variant="outlined"
                margin="normal"
                sx={textInputStyles}
                name="allocationPercentageThird"
                value={
                  formValues.allocationPercentageThird
                    ? formValues.allocationPercentageThird
                    : ""
                }
                error={!!formErrors.allocationPercentageThird}
                helperText={formErrors.allocationPercentageThird}
              />
              <TextField
                name="dobThird"
                label="Date of Birth"
                type="date"
                sx={textInputStyles}
                value={formValues.dobThird}
                error={!!formErrors.dobThird}
                helperText={formErrors.dobThird}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Select
                sx={textInputStyles}
                value={
                  formValues.relationShipThird
                    ? formValues.relationShipThird
                    : ""
                }
                required
                onChange={handleRelationShipThird}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <H4 style={{ color: "#C0C0C0" }}>RelationShip</H4>;
                  }
                  return selected;
                }}
              >
                <MenuItem disabled value="">
                  <H4>RelationShip</H4>
                </MenuItem>
                <MenuItem value={"Father"}>Father</MenuItem>
                <MenuItem value={"Mother"}>Mother</MenuItem>
                <MenuItem value={"Brother"}>Brother</MenuItem>
                <MenuItem value={"Sister"}>Sister</MenuItem>
                <MenuItem value={"Spouse"}>Spouse</MenuItem>
                <MenuItem value={"Children"}>Children</MenuItem>
              </Select>
              {gardianThird && (
                <>
                  <TextField
                    label="Guardian Name"
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    sx={textInputStyles}
                    name="guardianNameThird"
                    value={
                      formValues.guardianNameThird
                        ? formValues.guardianNameThird
                        : ""
                    }
                    error={!!formErrors.guardianNameThird}
                    helperText={formErrors.guardianNameThird}
                  />
                  <Select
                    sx={textInputStyles}
                    value={
                      formValues.guardianRelationshipThird
                        ? formValues.guardianRelationshipThird
                        : ""
                    }
                    required
                    onChange={handleGRelationShipThird}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return (
                          <H4 style={{ color: "#C0C0C0" }}>
                            Guardian RelationShip
                          </H4>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem disabled value="">
                      <H4>Guardian RelationShip</H4>
                    </MenuItem>
                    <MenuItem value={"Father"}>Father</MenuItem>
                    <MenuItem value={"Mother"}>Mother</MenuItem>
                    <MenuItem value={"Brother"}>Brother</MenuItem>
                    <MenuItem value={"Sister"}>Sister</MenuItem>
                    <MenuItem value={"Spouse"}>Spouse</MenuItem>
                    <MenuItem value={"Children"}>Children</MenuItem>
                  </Select>
                </>
              )}
              <Box sx={buttonContainer}>
                <Button variant="contained" onClick={handleSaveClick} sx={add}>
                  {data?.length === 3 ? "Update" : "Add"}
                </Button>
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default AddNomineeScreen;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const deleteButton = {
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 2,
  padding: 0.5,
  paddingLeft: 2,
  color: "#f00",
  paddingRight: 2,
  marginTop: 0.5,
  background: "#fff",
  fontSize: 14,
  position: "relative",
  textTransform: "none",
  width: {
    md: "50%",
    xs: "100%",
  },
  border: 1,
  borderColor: "#f00",
};
const selectedView = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "98%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
  height: 55,
};
const header = {
  width: 400,
  bgcolor: "#0152B4",

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  // justifyContent: "center",
  //alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: {
    md: "30%",
    xs: "100%",
  },
  justifyContent: "space-between",
  flexDirection: "row",
  display: "flex",

  mt: 2.5,
};

const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "100%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "30%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 1.5,
  },
};
